




















































import {Vue, Component, Prop} from "vue-property-decorator";
import {AdminAutomations} from "../../../../types/automations-list";
// @ts-ignore
import store from "../../../store";
import {FieldState, SelectOption, StackSetup} from "../../../../types";
import AdminAutomationsEnums from "../../../../enums/admin-automations-types/AdminAutomationsEnums";
import EventApi from "../../../api/EventsApi";
import AddAutomationModal from "./AddAutomationModal.vue";

@Component({})

export default class FieldDataTableDeck extends Vue {
    @Prop({required: true}) private automation!: AdminAutomations.Item;

    private automationsTypes: Array<SelectOption> = [
        {
            value: AdminAutomationsEnums.DEAL_TYPE,
            label: AdminAutomationsEnums.DEAL_TYPE_NAME
        }
    ];
    private isEditModeOn: boolean = false;

    /**
     * Текущее состояние игрового поля
     */
    private get currentGameField(): FieldState
    {
        return store.getters.getGameField;
    }

    /**
     * Является автоматизацией по раздаче карт
     * @private
     */
    private get isDealAutomation(): boolean
    {
        return this.automation.type === AdminAutomationsEnums.DEAL_TYPE;
    }

    /**
     * Список всех стопок
     * @private
     */
    private get stacksList(): Array<string|undefined>
    {
        return this.currentGameField.card_stacks.map((stack: StackSetup) => stack.title);
    }

    /**
     * Кому раздаем карты
     */
    private get targetsList(): Array<SelectOption>
    {
        return AddAutomationModal.targetsList;
    }

    /**
     * Название автоматизации
     * @private
     */
    private get automationName(): string
    {
        switch (this.automation.type) {
            case AdminAutomationsEnums.DEAL_TYPE:
                return AdminAutomationsEnums.DEAL_TYPE_NAME;
            case AdminAutomationsEnums.ENUMERATE_TYPE:
                return AdminAutomationsEnums.ENUMERATE_TYPE_NAME;
            default:
                return 'Undefined';
        }
    }

    /**
     * Удалить автоматизацию
     * @private
     */
    private deleteAutomation(): void
    {
        EventApi.triggerEvent(EventApi.DELETE_AUTOMATION, {id: this.automation.id});
    }

    /**
     * Редактировать автоматизацию
     * @private
     */
    private editAutomation(): void
    {
        this.isEditModeOn = true;
    }

    /**
     * Сохранить изменения автоматизацию
     * @private
     */
    private saveChanges(): void
    {
        this.isEditModeOn = false;

        const data: any = {
            id: this.automation.id,
            type: this.automation.type,
            sort: this.automation.sort,
            cardsCount: this.automation.data.cardsCount,
            target: this.automation.data.target,
            stackTitle: this.automation.data.stackTitle
        };

        EventApi.triggerEvent(EventApi.UPDATE_AUTOMATION, data);
    }
}
